import React from 'react';
/* eslint-disable */
export const AdvancedDifficulty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="45"
    width="84"
    viewBox="0 0 84 45"
    className="difficulty"
    data-testid="svg-advanced-difficulty"
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M52.73 36.62v-.51a15.26 15.26 0 0 0-15.13-15.4c-8.419.229-15.063 7.23-14.85 15.65v.51L9.77 37v-.51c-.14-16 12.29-29.09 27.75-29.22C52.98 7.14 65.62 20 65.75 36v.52l-13.02.1z"
      />
      <path
        fill="#F26422"
        d="M22.9 36.71v-.51c-.063-7.86 5.859-14.48 13.677-15.291 7.82-.81 14.973 4.455 16.523 12.161.2 1 13.54-2.36 13.16-1.61C64.098 17.576 52.19 7.307 38.14 7.21a28.75 28.75 0 0 0-28.5 29v.51l13.26-.01z"
      />
      <path
        fill="#333"
        d="M37.75 7.75c15.375 0 27.874 12.396 28 27.77l-12.25.1C53.429 26.972 46.398 20 37.75 20h-.13A15.75 15.75 0 0 0 22 35.88L9.75 36A28 28 0 0 1 37.52 7.75h.23zm0-1.75h-.25C21.072 6.143 7.867 19.572 8 36v1.75h1.75L22 37.63h1.75v-1.75a14 14 0 0 1 13.88-14.13h.12c7.685 0 13.934 6.195 14 13.88v1.75h1.75l12.25-.1h1.75V35.5C67.32 19.185 54.065 6.043 37.75 6z"
      />
      <path
        fill="#333"
        d="M37.77 37.75l-.58-3.48 37.17-4.39h.26c.2 0 .21 0 0 .08a2.44 2.44 0 0 1-.26.06l-.78.16-2 .42c-1.4.29-2.8.6-4.2.9l-4.3.91-4.56 1-4.6 1-4.42.93-4 .86-3.41.72-2.56.54-1.5.32-.26-.03z"
      />
    </g>
  </svg>
);
